import React, { useState, useEffect } from 'react';
import {servLoadClassRoomMaster} from "../../services/ide-apis";
import { Select, Tag } from 'antd';
import {getFromCache, setCache} from "../../services/cache-service";

const ClassRoomMasterLoader = ({
  classId: propClassId,
  onChange,
  showAllOption,
  selectMultiple,
  fullWidth = false
}) => {
  const [classId, setClassId] = useState(propClassId);
  const [classRooms, setClassRooms] = useState([]);

  const { Option } = Select;

  useEffect(() => {

    const cachedData = getFromCache('classroomMasterData');
    if (cachedData) {
      setClassRooms(cachedData);
    }
   else {
      const loadClassRoomMaster = async () => {
  
        try {
          const response = await servLoadClassRoomMaster();
          const data = response.data;
  
          if (data.statusCode === 200) {
            let rooms = data.classes;
    
            if (showAllOption) {
              rooms = [
                {
                  _id: 'all',
                  className: 'All',
                },
                ...rooms,
              ];
            }
    
            if (selectMultiple) {
              setClassId(Array.isArray(propClassId) ? propClassId : []);
            }
    
            setClassRooms(rooms);
            setCache('classroomMasterData',rooms)
          } else {
            console.error('Error loading class rooms', data);
          }
        } catch (error) {
          console.error('Error loading class rooms', error);
        }
      };
    
      loadClassRoomMaster();
    }
    
  }, [showAllOption, selectMultiple, propClassId,setClassId, setClassRooms]);

  useEffect(() => {
    setClassId(propClassId);
  }, [propClassId]);

  const classChanged = (selectedClassId) => {
    const index = classRooms.findIndex((cObj) => cObj._id === selectedClassId);

    try {
      onChange(selectedClassId, classRooms[index]);
    } catch (e) {}
    
    if (selectMultiple) {
      setClassId((prevIds) => [...prevIds, selectedClassId]);
    } else {
      setClassId(selectedClassId);
    }
  };

  const removeClass = (classIndex) => {
    setClassId((prevIds) => {
      const updatedIds = [...prevIds];
      updatedIds.splice(classIndex, 1);
      return updatedIds;
    });
  };

  const getClassName = (selectedClassId) => {
    const index = classRooms.findIndex((cObj) => cObj._id === selectedClassId);
    return index !== -1 ? classRooms[index].className : '';
  };

  return (
     <div>
      <Select
        value={classId}
        onChange={(value) => classChanged(value)}
        placeholder="Please select a class"
        style={{ width: fullWidth ? '100%' : '200px' }}
      >
        {classRooms.map((classRoom) => (
          <Option key={classRoom._id} value={classRoom._id}>
            {classRoom.className}
          </Option>
        ))}
      </Select>

      {selectMultiple && (
        <div>
          {classId.map((cId, index) => (
            <Tag key={index} className="m-r-xs" color="blue">
              {getClassName(cId)}
              <span className="pointerLink text-warning-lt" onClick={() => removeClass(index)}>
                <i className="fa fa-trash"></i>
              </span>
            </Tag>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClassRoomMasterLoader;
